import React from "react";
import AuthContext from "../context/AuthContext";
import { useContextSelector } from "use-context-selector";

const ParlayDial = ({ setShowDial, handelDialPad, clear ,setSetting}) => {
  const numberArrayCount = [1, 2, 3, 4, 5, 6, 7, 8, 9, 0, "00"];
  const numberArray = [10, 100, 200, 500];
  const profileData = useContextSelector(AuthContext, (ctx) => {
    return ctx.profileData;
  });
  return (
    <>
      <div data-v-ae096703 className="s-mb-2 s-flex">
        <div className="s-flex s-flex-1 s-justify-between">
          {(profileData?.stake?.length > 0
            ? profileData?.stake?.sort(function (a, b) {
                return a - b;
              })
            : numberArray
          )
            ?.slice(0, 4)
            ?.map((res) => {
              return (
                <button
                  onClick={() => {
                    handelDialPad(res);
                  }}
                  data-v-bf7df09e
                  className="btn s-btn-normal s-relative s-text-14px s-p-3 s-font-bold s-rounded s-flex s-justify-center s-items-center disabled:s-bg-black-300 dark:disabled:s-bg-black-700 disabled:s-text-black-600 dark:disabled:s-text-black-600 disabled:s-cursor-not-allowed s-overflow-hidden a active:s-bg-opacity-10 s-w-80px s-h-31px s-text-17px s-border-0"
                  type="button"
                  value={1000}
                >
                  <div
                    data-v-2f9c23fd
                    data-v-bf7df09e
                    className="wrapper s-w-full s-h-full s-absolute s-overflow-hidden s-top-0 s-left-0 s-z-10"
                    style={{ "--0b879273": "0" }}
                  >
                    <span
                      data-v-2f9c23fd
                      className="mask s-w-full s-h-full s-opacity-10 s-bg-black-900 s-absolute s-left-0 s-top-0"
                      style={{ display: "none" }}
                    />
                    <span
                      data-v-2f9c23fd
                      className="feedback s-block s-bg-white s-bg-opacity-25 s-rounded-full s-mix-blend-overlay s-absolute"
                      style={{ display: "none" }}
                    />
                  </div>
                  +{res}
                </button>
              );
            })}

          <button
          onClick={() => setSetting(true)}
            data-v-bf7df09e
            className="btn s-btn-normal s-relative s-text-14px s-p-3 s-font-bold s-rounded s-flex s-justify-center s-items-center disabled:s-bg-black-300 dark:disabled:s-bg-black-700 disabled:s-text-black-600 dark:disabled:s-text-black-600 disabled:s-cursor-not-allowed s-overflow-hidden a active:s-bg-opacity-10 s-w-31px s-h-31px s-border-0"
            type="button"
          >
            <div
              data-v-2f9c23fd
              data-v-bf7df09e
              className="wrapper s-w-full s-h-full s-absolute s-overflow-hidden s-top-0 s-left-0 s-z-10"
              style={{ "--0b879273": "0" }}
            >
              <span
                data-v-2f9c23fd
                className="mask s-w-full s-h-full s-opacity-10 s-bg-black-900 s-absolute s-left-0 s-top-0"
                style={{ display: "none" }}
              />
              <span
                data-v-2f9c23fd
                className="feedback s-block s-bg-white s-bg-opacity-25 s-rounded-full s-mix-blend-overlay s-absolute"
                style={{ display: "none" }}
              />
            </div>

            <span className="s-icon-setting s-text-17px" />
          </button>
        </div>
      </div>

      <div data-v-ae096703 className="s-flex">
        <div className="s-flex s-flex-1 s-flex-wrap s-text-14px">
          {numberArrayCount?.map((res) => {
            return (
              <button
                data-v-bf7df09e
                className="btn s-btn-normal s-relative s-text-14px s-p-3 s-font-bold s-rounded s-flex s-justify-center s-items-center disabled:s-bg-black-300 dark:disabled:s-bg-black-700 disabled:s-text-black-600 dark:disabled:s-text-black-600 disabled:s-cursor-not-allowed s-overflow-hidden a active:s-bg-opacity-10 s-w-2/12 s-h-40px s-flex s-justify-center s-items-center s-font-normal s-border s-border-white s-bg-black-100 dark:s-border-black-900 dark:s-bg-black-700 s-text-global-font-default-light dark:s-text-global-font-default-dark s-rounded"
                type="button"
                onClick={() => handelDialPad(res)}
              >
                <div
                  data-v-2f9c23fd
                  data-v-bf7df09e
                  className="wrapper s-w-full s-h-full s-absolute s-overflow-hidden s-top-0 s-left-0 s-z-10"
                  style={{ "--0b879273": "0" }}
                >
                  <span
                    data-v-2f9c23fd
                    className="mask s-w-full s-h-full s-opacity-10 s-bg-black-900 s-absolute s-left-0 s-top-0"
                    style={{ display: "none" }}
                  />
                  <span
                    data-v-2f9c23fd
                    className="feedback s-block s-bg-white s-bg-opacity-25 s-rounded-full s-mix-blend-overlay s-absolute"
                    style={{ display: "none" }}
                  />
                </div>
                {res}
              </button>
            );
          })}

          <button
            onClick={() => {
              clear();
            }}
            data-v-bf7df09e
            className="btn s-btn-normal s-relative s-text-14px s-p-3 s-font-bold s-rounded s-flex s-justify-center s-items-center disabled:s-bg-black-300 dark:disabled:s-bg-black-700 disabled:s-text-black-600 dark:disabled:s-text-black-600 disabled:s-cursor-not-allowed s-overflow-hidden a active:s-bg-opacity-10 s-icon-backspace s-w-2/12 s-h-40px s-flex s-justify-center s-items-center s-font-normal s-border s-border-white dark:s-bg-black-700 dark:s-border-black-800 s-bg-black-100 s-rounded s-text-global-font-default-light dark:s-text-global-font-default-dark"
          >
            <div
              data-v-2f9c23fd
              data-v-bf7df09e
              className="wrapper s-w-full s-h-full s-absolute s-overflow-hidden s-top-0 s-left-0 s-z-10"
              style={{ "--0b879273": "0" }}
            >
              <span
                data-v-2f9c23fd
                className="mask s-w-full s-h-full s-opacity-10 s-bg-black-900 s-absolute s-left-0 s-top-0"
                style={{ display: "none" }}
              />
              <span
                data-v-2f9c23fd
                className="feedback s-block s-bg-white s-bg-opacity-25 s-rounded-full s-mix-blend-overlay s-absolute"
                style={{ display: "none" }}
              />
            </div>
          </button>
        </div>
        <button
          onClick={() => setShowDial(false)}
          data-v-bf7df09e
          className="btn s-btn-normal s-relative s-text-14px s-p-3 s-font-bold s-rounded s-flex s-justify-center s-items-center disabled:s-bg-black-300 dark:disabled:s-bg-black-700 disabled:s-text-black-600 dark:disabled:s-text-black-600 disabled:s-cursor-not-allowed s-overflow-hidden a active:s-bg-opacity-10 s-flex s-justify-center s-items-center s-w-20 s-text-base s-font-bold s-border-solid s-border-l s-border-white dark:s-bg-black-700 dark:s-border-black-800 s-rounded s-bg-black-100 s-text-global-font-default-light dark:s-text-global-font-default-dark"
          type="button"
        >
          <div
            data-v-2f9c23fd
            data-v-bf7df09e
            className="wrapper s-w-full s-h-full s-absolute s-overflow-hidden s-top-0 s-left-0 s-z-10"
            style={{ "--0b879273": "0" }}
          >
            <span
              data-v-2f9c23fd
              className="mask s-w-full s-h-full s-opacity-10 s-bg-black-900 s-absolute s-left-0 s-top-0"
              style={{ display: "none" }}
            />
            <span
              data-v-2f9c23fd
              className="feedback s-block s-bg-white s-bg-opacity-25 s-rounded-full s-mix-blend-overlay s-absolute"
              style={{ display: "none" }}
            />
          </div>
          OK{" "}
        </button>
      </div>
    </>
  );
};

export default ParlayDial;
